"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var OnClickOutside = /** @class */ (function (_super) {
    __extends(OnClickOutside, _super);
    function OnClickOutside(props) {
        var _this = _super.call(this, props) || this;
        _this.outsideClick = _this.outsideClick.bind(_this);
        return _this;
    }
    OnClickOutside.prototype.componentDidMount = function () {
        document.addEventListener('click', this.outsideClick);
    };
    OnClickOutside.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.outsideClick);
    };
    OnClickOutside.prototype.render = function () {
        return this.props.children || null;
    };
    OnClickOutside.prototype.outsideClick = function (event) {
        this.props.events.onClickOutside();
    };
    return OnClickOutside;
}(React.Component));
exports.default = OnClickOutside;
//# sourceMappingURL=OnClickOutside.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/behaviors/OnClickOutside/OnClickOutside.js
// module id = 334
// module chunks = 8